<app-search></app-search>

<div class="row mt-3">
  <div class="col d-flex justify-content-between align-items-center">
    <h1>Saved Searches</h1>
    <!-- <button (click)="goToSearch()" class="btn btn-warning">Search</button> -->
  </div>
</div>

<ul class="list-group">
  <div *ngFor="let items of searchItems; let i = index;">

    <li class="list-group-item">
      <a [routerLink]="['/search', items.medium, items.q ]">
        <code>{{items.q}}</code> / {{items.medium}}
      </a>
      <button class="btn btn-danger btn-sm float-right" (click)="delete(items.id)">X</button>
    </li>

  </div>
</ul>